import { FC } from 'react';
import { TbMessage } from 'react-icons/tb';

import { Anchor, AnchorProps, Flex } from '@mantine/core';

import { FeedbackService } from 'services/FeedbackService';

const FeedbackButton: FC<Omit<AnchorProps, 'onClick'> & { label?: string; isInline?: boolean; hideIcon?: boolean }> = ({
    label = 'Leave feedback',
    isInline,
    hideIcon,
    fz: fontSize,
    ...props
}) => {
    return (
        <Anchor
            inherit
            style={() => ({
                display: isInline ? 'inline-flex' : 'flex',
                color: 'inherit',
                fontWeight: 400,
                textDecoration: 'underline',
            })}
            onClick={() => FeedbackService.open()}
            {...props}
        >
            <Flex gap={4} align="center">
                {!hideIcon && <TbMessage size={12} />}

                <span>{label}</span>
            </Flex>
        </Anchor>
    );
};

export { FeedbackButton };
